import { useEffect, useMemo, useState } from 'react';
import { Editor } from '@meitu/saas-editor-core';
import { ChartLayer } from '@meitu/saas-editor-core/es/layers/chart-layer';
import { IChartLayer, LayerType } from '@meitu/saas-editor-core/es/version-types';

/** 图表选中时才可调用 */
export const useLayerAndActiveChartInfo = (editor: Editor, layerId: string) => {
    const [layer, setLayer] = useState<IChartLayer>(() => editor.stage.getLayer(layerId) as IChartLayer);
    const activeChartInfo = useMemo(() => editor.getInstance(ChartLayer).getChartInfo(layer), [layer]);

    useEffect(() => {
        const newLayer = editor.active.getPick(true);
        if (newLayer?.layerType !== LayerType.CHART) return;
        setLayer(newLayer as IChartLayer);
        const listenerId = editor.stage.onLayerChange(() => {
            const newLayer = editor.active.getPick(true) ?? null;
            if (!newLayer || newLayer.layerType !== LayerType.CHART) return;
            setLayer(newLayer as IChartLayer);
        }, layerId);
        return () => {
            editor.off(listenerId);
        };
    }, [layerId]);

    return {
        layer,
        activeChartInfo,
    };
};
